import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWrench } from '@fortawesome/free-solid-svg-icons'

export default function AppManager(props){
    return(
        <main className="h-full dark:bg-gray-900 flex flex-col justify-items-center items-center">
            <FontAwesomeIcon icon={faWrench} size="6x" className={`mt-5 text-blue-600 dark:text-white invisible ${props.message ? 'visible' : 'invisible'}`} aria-hidden="true" />
            <div>
                {props.message.map((msg, key) => {
                    return(
                        <div key={key}>
                            <h1 className="text-black dark:text-white text-5xl mt-5">{msg}</h1>
                        </div>
                    )
                })}
            </div>
        </main>
    )
}